import React, { useState, useCallback } from "react";
import { useSelector, shallowEqual } from "react-redux";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

import { TeamReducerActions } from "reducers/teamReducer";
import KitContainer from "components/kit/KitContainer";
import TeamMemberCard from "components/general/TeamMemberCard";

const KitTeam = () => {
  const data = useSelector((state) => state.team.data, shallowEqual);
  const { getTeamData } = TeamReducerActions;
  const visibleItems = 20;
  const [displayedItems, setDisplayedItems] = useState(visibleItems);

  const handleViewMore = useCallback(() => {
    setDisplayedItems(
      (prevDisplayedItems) => prevDisplayedItems + visibleItems
    );
  }, [visibleItems]);

  return (
    <KitContainer
      header="Team"
      selectedState="team"
      getData={getTeamData}
      dataLength={data.length}
      displayViewMoreButton={data.length > displayedItems}
      visibleItems={visibleItems}
      setDisplayedItems={handleViewMore}
    >
      <Grid container>
        {data.slice(0, displayedItems).map((member) => {
          const {
            id,
            name,
            title_role,
            email,
            image,
            twitter_url,
            linkedin_url,
          } = member;
          return (
            <TeamMemberCard
              key={id}
              name={name}
              title={title_role}
              email={email}
              picture={image}
              twitter={twitter_url}
              linkedIn={linkedin_url}
            />
          );
        })}
      </Grid>
    </KitContainer>
  );
};

KitTeam.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      title_role: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      twitter_url: PropTypes.string,
      linkedin_url: PropTypes.string,
    })
  ),
};

export default React.memo(KitTeam);
